import { getTenantMemberships, isAuthTrialMember } from '@darice/auth-client';
import type { NavigateFunction } from 'react-router-dom';
import { DEFAULT_RETURN_TO, resolveReturnTo } from './returnTo';

export function postSignIn(search: string, navigate: NavigateFunction, offerSecurity: boolean): void {
  const params = new URLSearchParams(search);
  if (offerSecurity && isAuthTrialMember()) {
    params.set('do', 'security');
    navigate(`/?${params.toString()}`);
  } else if (getTenantMemberships().length > 1) {
    params.delete('do');
    const query = params.toString();
    navigate(`/tenant${query ? `?${query}` : ''}`);
  } else {
    window.location.href = resolveReturnTo(params.get('return_to')) ?? DEFAULT_RETURN_TO;
  }
}
